<script setup lang="ts">
import type {
  TpgScrollDownEvent,
  TpgScrollUpEvent,
} from '@tpg/grammar-web';
import type { Slot } from 'vue';

import type { GrammarModalHeaderHeadingPlacement } from './component-types';

export interface GrammarModalHeaderProps {
  headingPlacement?: GrammarModalHeaderHeadingPlacement;
  manualScroll?: boolean;
  stickyHeaderDivider?: boolean;
}

interface GrammarModalHeaderSlots {
  'leading-btn'?: Slot;
  'trailing-btn'?: Slot;
  'heading-badge'?: Slot;
  'menu-item'?: Slot;
}

const props = withDefaults(defineProps<GrammarModalHeaderProps>(), {
  headingPlacement: 'left',
  manualScroll: false,
  stickyHeaderDivider: true,
});

const emit = defineEmits<{
  scrollDown: [event: TpgScrollDownEvent];
  scrollUp: [event: TpgScrollUpEvent];
}>();

const slots = defineSlots<GrammarModalHeaderSlots>();

function onScrollDown(event: TpgScrollDownEvent) {
  emit('scrollDown', event);
}

function onScrollUp(event: TpgScrollUpEvent) {
  emit('scrollUp', event);
}
</script>

<template>
  <tpg-modal-header
    v-bind="props"
    @tpg-scroll-down="onScrollDown"
    @tpg-scroll-up="onScrollUp"
  >
    <div
      v-if="slots['leading-btn']"
      slot="leading-btn"
    >
      <slot name="leading-btn" />
    </div>

    <div
      v-if="slots['heading-badge']"
      slot="heading-badge"
    >
      <slot name="heading-badge" />
    </div>

    <div
      v-if="slots['trailing-btn']"
      slot="trailing-btn"
    >
      <slot name="trailing-btn" />
    </div>

    <div
      v-if="slots['menu-item']"
      slot="menu-item"
    >
      <slot name="menu-item" />
    </div>
  </tpg-modal-header>
</template>
